import './App.css';
import './components/post/editor/PostEditor.css';
import Box from '@mui/material/Box';
import React, {useEffect} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import {ThemeProvider} from '@mui/material/styles';
import {useSelector} from 'react-redux';
import Login from './components/Login';
import Header from './components/Header';
import {config} from './common/config/config';
import CultureForumCalendar from './components/cultureForum/CultureForumCalendar';
import CultureForumCalendarRegister from './components/admin/CultureForumCalendarRegister';
import CultureForumRegister from './components/admin/CultureForumRegister';
import CultureForumReplay from './components/cultureForum/CultureForumReplay';
import PostList from './components/post/PostList';
import PostWrite from './components/post/PostWrite';
import PostView from './components/post/PostView';
import PostUpdate from './components/post/PostUpdate';
import ClubRegister from "./components/admin/ClubRegister";
import BookRegister from "./components/admin/BookRegister";
import BookRentalList from "./components/post/BookRentalList";
import BookApplication from "./components/post/BookApplication";
import NoteBox from "./components/noteBox/NoteBox";
import AttendanceCalender from "./components/attendance/AttendanceCalender";
import MainPage from "./components/MainPage";
import NoticeBox from "./components/common/NoticeBox";
import NaviBox from "./components/common/NaviBox";
import EvaluatorRegister from "./components/admin/EvaluatorRegister";
import FleaMarketRegister from "./components/admin/FleaMarketRegister";
import {getThemeByMode} from './common/theme/theme';
import {RootState} from './reducer';

if (process.env.NODE_ENV === 'production') {
    config.serverPath = '/';
}

function App() {

    console.log('[App]');

    const themeMode = useSelector((state: RootState) => state.commonData.themeMode);
    const theme = getThemeByMode(themeMode);
    const isDark = themeMode === 'dark';

    useEffect(() => {
        document.body.setAttribute('data-scc-theme', themeMode);
    }, [themeMode]);

    const adminMenus = config.menu[config.menu.length - 1];
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Stack sx={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
            }}>
                <Box sx={{
                    position: 'fixed',
                    height: '100vh',
                    width: '100vw',
                    backgroundImage: 'url(/images/background.png)',
                    backgroundSize: 'cover',
                    zIndex: -1,
                    filter: isDark ? 'brightness(0.35) saturate(0.6)' : 'none',
                }}/>
                <BrowserRouter>
                    <Header/>
                    <Stack>
                        <NoticeBox/>
                        <NaviBox/>
                    </Stack>
                    <Routes>
                        <Route path={'/logIn'} element={<Login/>}/>
                        <Route path={'/'} element={<MainPage/>}/>
                        <Route path={config.menu[0].subMenu[0].path}
                               element={<CultureForumCalendar/>}/>
                        <Route path={config.menu[0].subMenu[1].path}
                               element={<CultureForumReplay/>}/>
                        <Route path={adminMenus.subMenu[0].path}
                               element={<CultureForumCalendarRegister/>}/>
                        <Route path={adminMenus.subMenu[1].path}
                               element={<CultureForumRegister/>}/>
                        <Route path={adminMenus.subMenu[2].path}
                               element={<ClubRegister/>}/>
                        <Route path={adminMenus.subMenu[3].path}
                               element={<BookRegister/>}/>
                        <Route path={adminMenus.subMenu[4].path}
                               element={<EvaluatorRegister/>}/>
                        <Route path={adminMenus.subMenu[5].path}
                               element={<FleaMarketRegister/>}/>
                        <Route path={config.url.board} element={<PostList/>}/>
                        <Route path={config.url.book} element={<BookRentalList/>}/>
                        <Route path={config.url.bookApplication} element={<BookApplication/>}/>
                        <Route path={config.url.postWrite} element={<PostWrite/>}/>
                        <Route path={config.url.postView} element={<PostView/>}/>
                        <Route path={config.url.postUpdate} element={<PostUpdate/>}/>
                        <Route path={`${config.url.noteBox}/*`} element={<NoteBox/>}/>
                        <Route path={`${config.url.attendance}/calendar`} element={<AttendanceCalender/>}/>
                        <Route path={'/'} element={<CultureForumCalendar/>}/>

                    </Routes>
                </BrowserRouter>
            </Stack>
        </ThemeProvider>
    );
}

export default App;
